import { render } from "./VideoRectOutline.vue?vue&type=template&id=3db7205f&scoped=true&ts=true"
import script from "./VideoRectOutline.vue?vue&type=script&lang=ts"
export * from "./VideoRectOutline.vue?vue&type=script&lang=ts"

import "./VideoRectOutline.vue?vue&type=style&index=0&id=3db7205f&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db7205f"]])

export default __exports__